import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

const TradingView = ({ widget_title }) => {
  const loadScript = () => {
    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/tv.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    script.onload = () => {
      try {
        if (document.getElementById("tradingview_35a2f")) {
          new window.TradingView.widget({
            autosize: true,
            symbol: widget_title,
            interval: "1",
            timezone: "Asia/Kolkata",
            theme: "light",
            style: "1",
            locale: "in",
            toolbar_bg: "#F1F3F6",
            enable_publishing: false,
            allow_symbol_change: true,
            container_id: "tradingview_35a2f",
          });
        }
      } catch (err) {}
    };
  };

  useEffect(() => {
    if (widget_title) {
      loadScript();
    }
  }, [widget_title]);

  return (
    <>
      {widget_title ? (
        <div class="tradingview-widget-container">
          <div id="tradingview_35a2f" style={{ height: "350px" }}></div>
        </div>
      ) : null}
    </>
  );
};

export default TradingView;
